(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/hooks/use-syndicate.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/hooks/use-syndicate.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const {
  notificationsSyndicateService
} = svs.myProfile.react.pages.notifications;

const useSyndicate = (setPlayerSyndicateData, setIsSyndicateOwner, setIsSyndicateMember, setShouldShowApiError) => {
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  useEffect(() => {
    const getData = async () => {
      try {
        svs.myProfile.logger.debug('Fetch Customers syndicate data from backend...');
        const rply = await notificationsSyndicateService.getSyndicateDataAsync();
        if (rply.status === 'success') {
          svs.myProfile.logger.debug('Fetch Customers Syndicate data from backend... success');
          setIsSyndicateOwner(rply.isSyndicateOwner);
          setIsSyndicateMember(rply.isSyndicateMember);
          setPlayerSyndicateData(rply.syndicateNotificationSettings);
        } else {
          setShouldShowApiError(true);
          svs.myProfile.logger.error('Fetch Customers Syndicate data from backend... error:', rply);
        }
      } catch (error) {
        svs.myProfile.logger.error('CommunicationSettings: catch: Fetch Customers syndicate error: ', error);
        setShouldShowApiError(true);
      }
    };
    if (isPlayerLoggedIn) {
      getData();
    }
  }, []);
};
useSyndicate.propTypes = {
  setIsSyndicateMember: PropTypes.func.isRequired,
  setIsSyndicateOwner: PropTypes.func.isRequired,
  setPlayerSyndicateData: PropTypes.func.isRequired,
  setShouldShowApiError: PropTypes.func.isRequired
};
svs.myProfile.react.pages.notifications.hooks.useSyndicate = useSyndicate;

 })(window);